module.exports = __webpack_public_path__ + "img/硫酸钡板.4bc0c2a9.jpg";